<template>
    <div v-html="formattedText"></div>
</template>

<script>
export default {
    data() {
        return {
            formattedText: ''
        };
    },
    mounted() {
        this.formatText();
    },
    watch: {
        $slots: 'formatText'
    },
    methods: {
        formatText() {
            const slotContent = this.$slots.default && this.$slots.default[0].text;
            if (slotContent && slotContent.includes('Hive Mind')) {
                this.formattedText = slotContent.replace(
                    'Hive Mind',
                    `<span class="text-orange">Hive Mind</span>`
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
